export default function() {
  return {
    municipalities: [],
    municipalitiesSimplified: [],
    locationsSimplified: [],
  };
}
